import type { FAQItem } from "@/components/FAQStructuredData";

/**
 * 这个页面 FAQ 的唯一真实来源,server 与 client 共用。
 *
 * 为什么单独成文件:page.tsx(server)要拿它生成 FAQPage JSON-LD,
 * FunnyFortunePageContent.tsx(client)要拿它渲染可见的 FAQ 区块。
 * 数据若定义在带 "use client" 的组件里再导出,server 侧拿到的是 client
 * reference,一 map() 就报 "Attempted to call map() from the server"。
 *
 * 必须两边共用同一份:Google 要求 FAQPage 声明的问答在页面上可见。此前
 * page.tsx 用的是 FAQStructuredData 里的 funnyFortuneFAQs,4 条问答与页面
 * 实际显示的完全不同(例如 schema 里有 "Are funny fortune cookies
 * appropriate for all ages?",页面上根本没有),属于结构化数据违规。
 */
export const faqData: FAQItem[] = [
  {
    question: "What makes fortune cookie messages funny?",
    answer:
      "Funny fortune cookie messages typically use unexpected twists, relatable modern humor, self-deprecating jokes, or absurdist wisdom that subverts traditional fortune cookie expectations.",
  },
  {
    question: "Can I use these funny fortunes for my own cookies?",
    answer:
      "Yes! These fortune messages are perfect for parties, events, or making your own homemade fortune cookies with a humorous twist.",
  },
  {
    question: "Are traditional fortune cookies supposed to be funny?",
    answer:
      "Traditional fortune cookies often contain inspirational messages or vague predictions. Funny fortune cookies are a modern twist that prioritizes humor over mysticism.",
  },
  {
    question: "How can I generate more funny fortune messages?",
    answer:
      "Try our AI Fortune Cookie Generator to create unlimited custom fortunes with different moods, including hilarious and witty options!",
  },
  // 下面几条是 2026-08 扩版时加的。前三条直接对着页面卡在 SERP 第二页的词形
  // 写(sayings / quotes / hilarious),最后一条是起源类问句。
  //
  // 关于起源那条,说清楚证据强度:抓到的竞品(everydaypower)把三个历史类问句
  // 做成了 H2,这通常是冲 People Also Ask 去的写法。但我们**没有实测到**这批词
  // 底下真的有 PAA —— 反爬挡住了 SERP feature 的抓取。所以这条是押注,不是结论;
  // 如果几个月后它没带来任何曝光,删掉它不用可惜。
  {
    question: "What are some short funny fortune cookie sayings?",
    answer:
      "The shortest ones land hardest because they fit on a real paper slip: The soup remembers. Trust the bees, question the wasps. Your future is currently buffering. Anything under about twelve words will fit inside a homemade cookie without folding twice.",
  },
  {
    question: "What is the difference between funny fortune cookie quotes and sayings?",
    answer:
      "In practice, nothing—people use both words for the same thing. Quotes usually means the one-liners you would repeat to somebody, while sayings leans toward proverb-shaped lines that sound like traditional wisdom until the last few words turn on you. This page has both.",
  },
  {
    question: "Where did fortune cookies come from?",
    answer:
      "Despite the name on the takeout box, fortune cookies are not traditionally Chinese. The most widely accepted account traces them to California in the early 1900s, made by Japanese and Chinese immigrant bakers, and they spread across American Chinese restaurants from there. The funny fortune is a much more recent invention.",
  },
];
